import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=b660abac&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b660abac')) {
      api.createRecord('b660abac', component.options)
    } else {
      api.reload('b660abac', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=b660abac&", function () {
      api.rerender('b660abac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qc23xah3NoK0/JS/comp/childrenage.vue"
export default component.exports